import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import moment from "moment";
import { z } from "zod";
import { Form } from "@/components/ui/form";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { Input } from "@/components/ui/input";
import RoadmapTable from "./roadmapTable";
import Paginat from "@/components/lib/paginat";
import FormInputField from "@/components/lib/from-input-field";
import { Search } from "lucide-react";
import { TabsContent } from "@/components/ui/tabs";
import { useDispatch, useSelector } from "react-redux";
import { useState, useEffect, useMemo } from "react";
import useAuth from "@/hooks/useAuth";
import { useSearch } from "@/hooks/useSearch";
import OnlyTableSekeleton from "@/components/skeleton/only-table-skeleton";
import { fetchPresentDataByDate } from "@/redux/slice/staff-management/time-sheet-slice";

const schema = z.object({
  date: z.string().optional(),
});

function RoadmapTabs() {
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const { user } = useAuth();
  const [firstLoading, setFirstLoading] = useState(true);
  const [tableLoading, setTableLoading] = useState(false);
  const [searchText, setSearchText] = useState("");

  const form = useForm({
    resolver: zodResolver(schema),
    defaultValues: {
      date: new Date(),
    },
  });
  const selectedDate = form.watch("date");

  const currentDate = selectedDate
    ? moment(selectedDate).format("YYYY-MM-DD")
    : moment().format("YYYY-MM-DD");

  const { getPresentLoading, presentData } = useSelector(
    (state) => state.staffManage.timeSheet
  );

  const attendancesList = useMemo(() => {
    if (Array.isArray(presentData?.attendances)) return presentData.attendances;
    if (Array.isArray(presentData?.data)) return presentData.data;
    if (Array.isArray(presentData)) return presentData;
    return [];
  }, [presentData]);

  const searchData = useSearch(
    attendancesList,
    searchText,
    ["designation", "name", "staff_id"],
    300
  );

  useEffect(() => {
    if (!user?.restaurant_id) return;

    let isMounted = true;
    const fetchData = async () => {
      setTableLoading(true);
      try {
        await dispatch(
          fetchPresentDataByDate({
            restaurant_id: user?.restaurant_id,
            date: currentDate,
            page: page,
            perPage: perPage,
          })
        );
      } catch (err) {
        console.error("Error fetching present data:", err);
      } finally {
        if (isMounted) {
          setFirstLoading(false);
          setTableLoading(false);
        }
      }
    };

    fetchData();

    return () => {
      isMounted = false;
    };
  }, [currentDate, user?.restaurant_id, dispatch, page, perPage]);

  return (
    <TabsContent value="roadmap">
      <div>
        <div className="w-full flex justify-between lg:flex-row flex-col gap-5 items-start lg:items-center">
          <div className="md:w-1/2 w-full">
            <Form {...form}>
              <form className="w-64">
                <FormInputField
                  name="date"
                  placeholder={"dd/mm/yy"}
                  form={form}
                  type="date"
                  style="bg-cblack3 text-cwhite2"
                  label={"Search By Date"}
                />
              </form>
            </Form>
          </div>
          <div>{/* <h2 className="text-cyellow">Total Staff: 50</h2> */}</div>
          <div className="md:w-1/2 w-full flex flex-col  gap-1.5 justify-end items-end">
            <div className="flex gap-3 justify-center items-center">
              <div className="relative">
                <Search
                  size={18}
                  className="text-cwhite3 absolute top-2 left-2"
                />
                <Input
                  onChange={(e) => setSearchText(e.target.value)}
                  placeholder="Search by Name or ID"
                  className="bg-cblack3 pl-8"
                />
              </div>
              <div className="flex gap-1 justify-center items-center">
                <h3 className="text-white">Show</h3>
                <Select
                  onValueChange={(value) => setPerPage(Number(value))}
                  value={perPage.toString()}
                >
                  <SelectTrigger className="w-[60px]">
                    <SelectValue placeholder="10" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectGroup>
                      <SelectItem value="10">10</SelectItem>
                      <SelectItem value="20">20</SelectItem>
                      <SelectItem value="40">40</SelectItem>
                    </SelectGroup>
                  </SelectContent>
                </Select>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-5">
          {firstLoading || tableLoading ? (
            <OnlyTableSekeleton header={false} />
          ) : (
            <RoadmapTable selectedDate={selectedDate} data={searchData} />
          )}
        </div>
        <div>
          <Paginat
            pagination={presentData?.pagination}
            onPageChange={(page) => setPage(page)}
            className="mt-4"
          />
        </div>
      </div>
    </TabsContent>
  );
}

export default RoadmapTabs;

const dateSchema = z.object({
  date: z.string().min(1, "Date is required"),
});
